import React from 'react';

const EnvVarTest = () => {
  const envVars = {
    'NODE_ENV': process.env.NODE_ENV,
    'REACT_APP_SUPABASE_URL': process.env.REACT_APP_SUPABASE_URL,
    'REACT_APP_SUPABASE_ANON_KEY': process.env.REACT_APP_SUPABASE_ANON_KEY ? 'Set' : 'Missing',
    'REACT_APP_OPENAI_API_KEY': process.env.REACT_APP_OPENAI_API_KEY ? 'Set' : 'Missing',
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-2xl font-bold mb-4">Environment Variables Test</h2>
      
      <div className="space-y-2">
        {Object.entries(envVars).map(([key, value]) => (
          <div key={key} className={`p-3 rounded border ${
            value === 'Missing' ? 'bg-red-50 border-red-200' : 'bg-green-50 border-green-200'
          }`}>
            <div className="font-semibold">{key}</div>
            <div className="text-sm text-gray-600">
              {key.includes('KEY') && value !== 'Missing' ? 'Set (hidden for security)' : value}
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded">
        <h3 className="font-semibold text-blue-800">Instructions:</h3>
        <p className="text-sm text-blue-700 mt-2">
          If you see "Missing" for REACT_APP_SUPABASE_ANON_KEY, you need to set it in your Vercel environment variables.
        </p>
      </div>
    </div>
  );
};

export default EnvVarTest; 